import { defineStore } from 'pinia';

export const usePersonaStore = defineStore('persona', {
    state: () => ({
        personas: [] as any[],
        persona: null as any | null,
    }),
    actions: {
        async fetchPersonas() {
            return useNuxtApp().$api().v2.personas.list({
                retry: 3,
                retryDelay: 1500,
            }).then(response => {
                this.personas = response
                return response;
            });
        },
        async fetchPersona(id: string) {
            this.persona = await useNuxtApp().$api().v2.personas.get(id);
        },
    }
})